import { toast } from "react-toastify";
import {
    educationApplication,
    EducationApplicationRequest,
    getAllExpertAreas,
    getAllMeasures,
    getAllOperationTypes,
    getFarmHolder,
    getFarmMembers,
} from "services";
import { AppThunk } from "store";
import {
    getEducationApplicationSuccess,
    getExpertAreasError,
    getExpertAreasRequest,
    getExpertAreasSuccess,
    getFarmHolderError,
    getFarmHolderRequest,
    getFarmHolderSuccess,
    getFarmMembersError,
    getFarmMembersSuccess,
    getMeasuresError,
    getMeasuresRequest,
    getMeasuresSuccess,
    getOperationTypesError,
    getOperationTypesRequest,
    getOperationTypesSuccess,
} from ".";
import { getEducationsApplicationError } from "./EducationsSlice";

export const getMeasures = (): AppThunk => async (dispatch, getState) => {
    try {
        const { signIn, measures } = getState();
        if (signIn.user && !measures.items?.length) {
            dispatch(getMeasuresRequest());
            const { accessToken } = signIn.user;
            const response = await getAllMeasures(accessToken);

            dispatch(getMeasuresSuccess({ measures: response.data.measures }));
        }
    } catch (error: any) {
        dispatch(getMeasuresError({ errorMessage: error }));
    }
};

export const getOperationTypes = (): AppThunk => async (dispatch, getState) => {
    try {
        const { signIn, operationTypes } = getState();

        if (signIn.user && !operationTypes.items?.length) {
            dispatch(getOperationTypesRequest());
            const { accessToken } = signIn.user;
            const response = await getAllOperationTypes(accessToken);

            dispatch(
                getOperationTypesSuccess({
                    operationTypes: response.data.operationTypes,
                })
            );
        }
    } catch (error: any) {
        dispatch(getOperationTypesError({ errorMessage: error }));
    }
};

export const getExpertAreas = (): AppThunk => async (dispatch, getState) => {
    try {
        const { signIn, expertAreas } = getState();

        if (signIn?.user && !expertAreas.expertAreas?.length) {
            dispatch(getExpertAreasRequest());
            const { accessToken } = signIn.user;
            const response = await getAllExpertAreas(accessToken);

            dispatch(
                getExpertAreasSuccess({
                    expertAreas: response.data.expertAreas,
                })
            );
        }
    } catch (error: any) {
        dispatch(getExpertAreasError({ errorMessage: error }));
    }
};

// TODO: this should be implemented using react-query
export const getHolderFarm = (): AppThunk => async (dispatch, getState) => {
    try {
        const { signIn, profile } = getState();
        if (signIn.user && profile.profile) {
            dispatch(getFarmHolderRequest());

            const { accessToken } = signIn.user;
            const { mibpg } = profile.profile;

            const response = await getFarmHolder(accessToken, mibpg);

            dispatch(
                getFarmHolderSuccess({
                    farmHolder: response.data,
                })
            );
        }
    } catch (error) {
        dispatch(
            getFarmHolderError({
                errorMessage: "Problem prilikom dohvaćanja podataka, pokušajte ponovno...",
            })
        );
    }
};

// TODO: this should be implemented using react-query
export const getMembersFarm = (): AppThunk => async (dispatch, getState) => {
    try {
        const { signIn, profile } = getState();

        if (signIn.user && profile.profile) {
            dispatch(getFarmHolderRequest());

            const { accessToken } = signIn.user;
            const { mibpg } = profile.profile;

            const response = await getFarmMembers(accessToken, mibpg);

            dispatch(
                getFarmMembersSuccess({
                    farmMembers: response.data,
                })
            );
        }
    } catch (error: any) {
        dispatch(
            getFarmMembersError({
                errorMessage: "Problem prilikom dohvaćanja podataka, pokušajte ponovno...",
            })
        );
    }
};

// TODO: this should be implemented using react-query
export const educationSignUp =
    (data: Omit<EducationApplicationRequest, "enrolled">): AppThunk =>
    async (dispatch, getState) => {
        try {
            const { signIn, profile } = getState();

            if (signIn.user && profile.profile) {
                // dispatch(getEducationsRequest());

                const { accessToken } = signIn.user;
                const { mibpg } = profile.profile;
                data.mibpg = mibpg == "" ? data.mibpg : mibpg;
                const response = await educationApplication(accessToken, {
                    enrolled: 1,
                    ...data,
                });
                dispatch(getEducationApplicationSuccess({ response: response.data }));
                toast.success(response.data.response.notice[0]);
            }
        } catch (error: any) {
            dispatch(getEducationsApplicationError({ error: true }));
            const errorNotice = error.response.data.response.notice;
            toast.error(
                typeof errorNotice == "undefined"
                    ? "Problem prilikom spremanja podataka, pokušajte ponovno..."
                    : "Već ste prijavljeni na ovaj tečaj"
            );
        }
    };
